import {Link, Text} from '#component/base';
import {AuthCTAMessages} from '#component/partial';
import {sprinkles} from '#style/sprinkles';

export const VerifyPendingUnauthed: React.FC<{}> = () => (
  <>
    <AuthCTAMessages
      title="Verify your account"
      messages={[
        <div className={sprinkles({direction: 'col', flex: 'flex', gap: 72})} key={1}>
          <Text as="p" color="doveGray">
            If you have previously created an account, a verification email was sent to the email
            address provided. Please click the link inside to complete the registration process.
          </Text>

          <div>
            <Text as="p" color="doveGray">
              Didn’t receive your email?
            </Text>

            <Text as="p" color="doveGray">
              Please log in again to resend the verification email.
            </Text>
          </div>
        </div>,
      ]}
    />

    <Text color="doveGray" textAlign="center">
      <Link href="/signin">Log in</Link>
    </Text>
  </>
);
